"use strict";
exports.__esModule = true;
//# sourceMappingURL=investors-redirect-block-slice.js.map